import { Box, TableContainer } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const FormWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const LayerTableContainer = styled(TableContainer)`
  height: 300px;
  overflow: auto;

  .fullscreen & {
    height: auto;
    flex: 1;
    min-height: 0;
  }
`;
